import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { FC } from "react";
import { useMemo } from "react";
import DurationService from "app/services/DurationService";

export const TrafficEngagementComparePopSubtitleV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;

    const forWidget = useMemo(() => {
        if (!widget) {
            return [];
        }

        return DurationService.getDurationData(
            widget._widgetConfig.properties.duration,
            widget._widgetConfig.properties.comparedDuration,
            widget.getWidgetMetricConfig().component,
        ).forWidget;
    }, [widget]);

    return (
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div
                style={{
                    backgroundColor: "#cacaca",
                    width: 10,
                    height: 10,
                    borderRadius: 3,
                    margin: "4 4 0 2",
                }}
            >
                <div
                    style={{
                        width: 6,
                        borderBottom: "1 solid #595959",
                        transform: "translateY(3) translateX(4) rotate(45deg)",
                    }}
                />
                <div
                    style={{
                        width: 10,
                        borderBottom: "1 solid #595959",
                        transform: "translateY(3) translateX(-1) rotate(45deg)",
                    }}
                />
                <div
                    style={{
                        width: 6,
                        borderBottom: "1 solid #595959",
                        transform: "translateY(4) translateX(-1) rotate(45deg)",
                    }}
                />
            </div>
            <div
                data-automation="previous period"
                style={{ marginRight: 8 }}
            >
                {forWidget[1]}
            </div>
            <div
                style={{
                    backgroundColor: "#cacaca",
                    width: 10,
                    height: 10,
                    borderRadius: 3,
                    margin: 4,
                }}
            />
            <div
                data-automation="current period"
                style={{ marginRight: 8 }}
            >
                {forWidget[0]}
            </div>
        </div>
    );
};
